// extracted by mini-css-extract-plugin
export default {"dataViewContainer":"DrawTerritorySidebar_dataViewContainer__6YPKA"};